import { StateType } from './types';

export default (): StateType => ({
  loading: true,
});
